import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'
import { app } from '@/main'

const loginModule = {
  state: {},
  actions: {
    async LOGIN({ commit }, payload) {
      // console.log('LOGIN payload: ', payload)
      try {
        const res = await baseFetch(
          API.postLogin.url,
          API.postLogin.method,
          payload
        )

        if (!res.isError && res.data) {
          const data = {
            ...res.data.data,
            communityId: '8d048b06-88c5-4028-98a7-bc4e66714d90'
          }
          localStorage.setItem('userToken', data.token)
          // 儲存登入用戶資料
          commit('userModule/SET_USERINFO', data, { root: true })
          // 儲存登入用戶社區ID
          commit('commonModule/SET_CURRENT_COMMUNITY_ID', data.communityId, {root: true})
          app.$router.push('/')
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async LOGOUT({ commit }) {
      // localStorage.removeItem('userToken')
      // const demoData = {
      //   name: 'Eric chien',
      //   account: '',
      //   permission: true,
      //   communityId: ''
      // }
      // commit('userModule/SET_USERINFO', demoData, { root: true })
      return baseFetch(
        API.logout.url,
        API.logout.method,
        {
          'platform': 4
        }
      )
    }
  },
  mutations: {},
  getters: {},
  namespaced: true
}

export default loginModule
